import React, { FC } from "react"

import { SVG } from "./SVG"

export const ChevronLeftIcon: FC = props => (
  <SVG {...props} width="12" height="22" viewBox="0 0 12 22" fill="none">
    <path d="M11 1L1 11L11 21" stroke="currentColor" strokeLinecap="round" />
  </SVG>
)
